import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-4 mb-3" }, "Área do Cliente - Login")
], -1)
const _hoisted_7 = { class: "col-md-12 text-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "cpf",
  class: "form-label"
}, "CPF", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "senha",
  class: "form-label"
}, "Senha", -1)
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = ["type"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "col-md-12 d-grid gap-2" }
const _hoisted_19 = {
  key: 0,
  class: "mt-3 text-primary"
}
const _hoisted_20 = {
  key: 1,
  class: "mt-3 text-danger"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)

import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

//services
import * as clienteService from "@/services/clienteService";
import storeControle from "@/utils/storeControle";
import { getToken } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {


//vue
const router = useRouter();

var controle = reactive({
  model: {} as clienteService.ClienteLogin,
  status: "" as string,
  erro: "" as string,
  tipoSenha: "password" as string
})


function login() {

  // Lógica de login aqui
  controle.status = "Realizando login...";
  console.log("Login:", controle.model);

  clienteService.Login(controle.model)
    .then((r) => {
      storeControle.usuario = {} as clienteService.ClienteLoginResult;
      storeControle.token = r.accessToken;
      storeControle.usuario.clienteId = r.clienteId;
      storeControle.usuario.nome = r.nome;
      storeControle.usuario.refreshToken = r.refreshToken;
      storeControle.usuario.userName = r.userName;

      controle.status = "Entrando...";
      console.log("Entrando com sucesso:", r);

      // Armazenar o token no localStorage ou cookies, se necessário
      localStorage.setItem("clienteToken", r.accessToken);
      localStorage.setItem('user', JSON.stringify(r));

      // Redirecionar para a área do cliente após o login bem-sucedido

      router.push({ name: "PainelCliente" });
    })
    .catch((error) => {
      controle.status = "";
      controle.erro = error.message || error;
    });
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _unref(imgLogin),
              alt: "Login do Cliente",
              class: "img-fluid"
            }, null, 8, _hoisted_8)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "cpf",
              placeholder: "Digite seu CPF",
              inputmode: "numeric",
              autocomplete: "username",
              maxlength: "14",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).model.cpf) = $event)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (login()), ["enter"]))
            }, null, 544), [
              [_vModelText, _unref(controle).model.cpf]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: _unref(controle).tipoSenha,
                class: "form-control",
                id: "senha",
                placeholder: "Digite sua senha",
                autocomplete: "current-password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.senha) = $event)),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (login()), ["enter"]))
              }, null, 40, _hoisted_15), [
                [_vModelDynamic, _unref(controle).model.senha]
              ]),
              _createElementVNode("span", {
                class: "input-group-text",
                role: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(controle).tipoSenha = (_unref(controle).tipoSenha === 'password' ? 'text' : 'password')))
              }, _hoisted_17)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (login()))
            }, "Entrar")
          ]),
          (_unref(controle).erro == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(controle).status), 1))
            : _createCommentVNode("", true),
          (_unref(controle).erro != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(controle).erro), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_21
    ])
  ], 64))
}
}

})